import api from "./api";
import businessUnitsManager from "./BusinessUnits";

class AziendeGruppoManager {

    aziendeGruppo(config?: any) {
        return api.get(`/aziendegruppo`, config)
    }

    aziendaGruppo(id: number | string) {
        return api.get(`/aziendegruppo/${id}`)
    }

    saveContabilita(id: number | string, data: any) {
        return api.post(`/aziendegruppo/${id}/contabilita`, data)
    }

    contabilita(id: number | string) {
        return api.get(`/aziendegruppo/${id}/contabilita`)
    }

    fetchByContabilitaPermission() {
        return api.get(`/aziendegruppo/by_contabilita_permission`)
    }

    retrieve = this.aziendaGruppo
    list = this.aziendeGruppo
    paginatedList = this.list
}

const aziendeGruppoManager = new AziendeGruppoManager()

class AziendeGruppoBuManager {

    businessUnitAziendaGruppo(id: number | string, config?: any) {
        return api.get(`/aziendegruppo/${id}/business_units`, config)
    }

    saveBusinessUnits(id: number | string, data: any) {
        return api.put(`/aziendegruppo/${id}/business_units`, data)
    }

    retrieve = businessUnitsManager.retrieve
    list = this.businessUnitAziendaGruppo
}

const aziendeGruppoBuManager = new AziendeGruppoBuManager()

export { aziendeGruppoManager, aziendeGruppoBuManager }
